// File: IncomeTaxTDSReturnsITRFilings.jsx
import React from "react";

export default function IncomeTaxTDSReturnsITRFilings() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Income Tax, TDS, PF Returns &amp; ITR Filings
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks ensures accurate and timely tax return filings.
          </p>
          <p className="text-gray-700">
            Complete compliance including ITR-1 to ITR-7 e-filing, quarterly TDS returns (24Q/26Q/27Q), PF/ESI returns, Form 16/16A issuance, advance tax calculations, and Income Tax portal DSC/EVC verification.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Income Tax TDS PF returns filing) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/590021/pexels-photo-590021.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Income Tax TDS PF returns ITR filing compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation organization for all tax filings.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Financial statements and books of accounts</li>
                <li>PAN cards of entity and authorized signatory</li>
                <li>Form 16/16A/26AS/26Q certificates</li>
                <li>Bank statements and investment proofs</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Tax compliance precision ensuring zero penalties and maximum refunds.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Complete ITR E-Filing (ITR-1 to ITR-7)
                </h3>
                <p className="text-gray-700 text-sm">
                  All ITR forms including ITR-1 (simple salary), ITR-2 (capital gains), ITR-3 (business income), ITR-4 (presumptive), ITR-5 (firms/LLPs), ITR-6 (companies), ITR-7 (trusts) with accurate 26AS/AIS/TIS reconciliation, deductions claims (80C-80U), TCS/TDS credit, refund processing, and belated return filing upto 31st Dec.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  TDS Returns Perfection (24Q/26Q/27Q)
                </h3>
                <p className="text-gray-700 text-sm">
                  Quarterly TDS compliance including Form 24Q (salary), 26Q (non-salary), 27Q (NRI), 27EQ (TCS), Form 16/16A certificate generation, late fee waiver applications, correction statements, PAN demand resolution, and TRACES compliance ensuring zero TDS defaults and interest penalties.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  PF/ESI Statutory Returns
                </h3>
                <p className="text-gray-700 text-sm">
                  Monthly/quarterly PF returns (Form 5/10/12A), ESI returns, professional tax challans, advance tax calculations (90% coverage), interest u/s 234A/B/C computation, tax audit report (44AB) coordination, assessment proceedings representation, and refund bank account linkage for seamless compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
